/* フローティングメニュー */
import React from 'react';
import ReturnMenuButton from '../molecules/ReturnMenuButton';

interface Props {
  is_staff: boolean;
  is_on_change: boolean;
}

const FloatingMenu: React.FC<Props> = ({ is_staff, is_on_change }) => {
  return (
    <div className="floating-menu">
      <ReturnMenuButton is_staff={is_staff} is_on_change={is_on_change} />
    </div>
  );
};

export default FloatingMenu;
